export enum Protocol {
    HTTP = 80,
    HTTPS = 443,
    RTSP = 554,
    RTSP_H264 = 100554,
    RTSP_MJPG = 200554,
}
